module.exports = __webpack_public_path__ + "public/Icons/orderIcondashboard.png?0c5aac13";